<div appModal (closeModal)="close()">
  <section class="modal-title-container">
    <img
      alt="info-image"
      src="/assets/images/rebrand/event-purchase-page/breakdown-info-modal.png"
      srcset="
        /assets/images/rebrand/event-purchase-page/breakdown-info-modal@2x.png 2x,
        /assets/images/rebrand/event-purchase-page/breakdown-info-modal@3x.png 3x
      "
    />
    <p class="text-xl font-bold mt-25">What is Game Breakdown?</p>
    <p class="text-lg mt-15 leading-normal">
      When you purchase a game breakdown, our NextPro experts will identify all the plays in your game. Your game will
      come with a breakdown timeline that lets you quickly browse, clip and share all the action without watching the
      entire game.
    </p>
  </section>

  <section class="modal-actions-container mt-10">
    <button alt="Confirm" class="btn btn-lg mx-auto px-50" (click)="close()">OK</button>
  </section>
</div>
